<template lang="pug">
  .exchange
    form
      .field
        input(
          type="text"
          value="You have"
          disabled="true"
        )
        span.append {{baseAmount}} {{baseAsset.code}}
      .field
        input(
          type="number"
          placeholder="Size"
        )
        span.append {{baseAsset.code}}
      .field
        input(
          type="number"
          placeholder="Price"
        )
        span.append {{quoteAsset.code}}
      .field
        input(
          type="number"
          placeholder="Sum"
        )
        span.append {{quoteAsset.code}}
    .buttons
      button.buy Buy
      button.sell Sell
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        baseAmount: 1
      }
    },
    computed: {
      ...mapState(['baseAsset', 'quoteAsset'])
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"
  @import "@/assets/styles/extends/button.sass"
  @import "@/assets/styles/forms.sass"

  .exchange
    border-left: $border

  form
    border-bottom: $border

    input[disabled]
      background-color: inherit

  .field
    .append
      // cursor: pointer

    &:not(:last-of-type) input
      border-bottom: $border

  .buttons
    width: 100%

  button
    @extend %button

    width: 50%

    &.buy
      color: #4caf50

    &.sell
      color: #ff5353

    &:not(:last-of-type)
      border-right: $border
</style>
